import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBl81i7GBjQXRllf7k-YJV-VbCXh6Zhd7E",
  authDomain: "share-joy.firebaseapp.com",
  databaseURL: "https://share-joy.firebaseio.com",
  projectId: "share-joy",
  storageBucket: "share-joy.appspot.com",
  messagingSenderId: "403486025414",
  appId: "1:403486025414:web:1463b6718bac84d3e699c7",
  measurementId: "G-CPB9SXEE4F",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
